export const ResourcesController = {
    index(): void {},
};
